
import * as UiConfig from 'Flow2/components/CustomCollections/CustomDataConfig/CustomUiConfig';
import { isPMDB, isNLW } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController';

export const createInlineScript = ({ type = null, text = null }) => {
    let script = document.createElement('script');
    if (type) script.type = type;
    if (text) {
        let inlineScript = document.createTextNode(text);
        script.appendChild(inlineScript);
    }
    document.head.appendChild(script);
}

export const createScript = ({ src = null, id = null, type = null, async = false, defer = null }) => {
    let script = document.createElement('script');
    script.async = async;
    if (defer) script.defer = defer;
    if (src) script.src = src;
    if (id) script.id = id;
    if (type) script.type = type;

    document.body.appendChild(script);
}

export const loadGapiScript = (param = null) => {
    if (UiConfig.TRACKING_ID === "") {
        loadAnalyticsScript(param);
    }

    createScript({ src: UiConfig.GAPI_URL, async: true, defer: true });
    createScript({ src: UiConfig.GAPI_AUTH_URL });
}

export const loadAnalyticsScript = (param = null) => {
    if (UiConfig.TRACKING_ID !== "" || (param && param !== "")) {
        let trackingId = UiConfig.TRACKING_ID || param;
        let text = "var _gaq =  _gaq || []; _gaq.push(['_setAccount', ' " + trackingId + "']); _gaq.push(['_trackPageView']);";
        createInlineScript({ type: "text/javascript", text: text });
        console.log("AnalyticsScript");
    }
}
export const loadCookieScript = () => {
    createScript({ src: UiConfig.JQUERY_URL, type: "text/javascript" });
    createScript({ src: UiConfig.JQUERY_MIN_URL, type: "text/javascript" });
    createScript({ src: UiConfig.LLGC_COOKIE_URL, id: UiConfig.LLGC_ID });
}

export const loadScriptsForApp = (script, param = null) => {
    switch (script) {
        case "gapi":
            if (UiConfig.showCustomAnalytics && isPMDB()) {
                loadGapiScript(param);
            }
        case "customerscript":
            if (isNLW()) {
                //loadCookieScript();
            }

            if (UiConfig.showCustomAnalytics && isPMDB()) {
                loadAnalyticsScript();
            }
        default:
            break;
    }
}